import { store } from 'v3/data/store';
import { preferenceOptionsSlice } from 'v3/data/store/preferenceOptions';
import { IPreferenceOptionItem } from 'v3/data/store/preferenceOptions/types';


export const setPreferenceOptionList = (preferenceOptions: IPreferenceOptionItem[]) => {
  store.dispatch(preferenceOptionsSlice.actions.setPreferenceOptionList(preferenceOptions));
};